import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function addClassifyMsg(data) {
  return request({
    url: URL.sys.addClassifyMsg,
    method: 'post',
    data
  })
}

export function updateClassifyMsg(data) {
  return request({
    url: URL.sys.updateClassifyMsg,
    method: 'put',
    data
  })
}

export function removeClassifyMsg(data) {
  return request({
    url: URL.sys.removeClassifyMsg,
    method: 'delete',
    data
  })
}

export function getClassifyMsg() {
  return request({
    url: URL.sys.getClassifyMsg,
    method: 'get'
  })
}

export function pageClassifyMsg(data) {
  return request({
    url: URL.sys.pageClassifyMsg,
    method: 'post',
    data
  })
}

export function checkClassifyMsg(code) {
  return request({
    url: URL.sys.checkClassifyMsg,
    method: 'get',
    params: { code }
  })
}

